(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('CurrencyPairConfiguration', CurrencyPairConfiguration);

        CurrencyPairConfiguration.$inject = ['$resource'];

    function CurrencyPairConfiguration ($resource) {
		var resourceUrl =  '/api';
		return $resource(resourceUrl, {}, {
		    'get' : {
			    method : 'GET',
			    params: {id : '@id'},
			    url:'api/manage-currency-pair-configuration/:id',
			    transformResponse : function(data) {
                 if (data) {
                    return angular.fromJson(data);
                    }
                    return data;
			    }
		    },
            'getBankCurrencyPairConfiguration': {
                method: 'GET',
                isArray: true,
                params: {bankId:'@bankId'},
                url: 'api/manage-bank-currency-pair-configuration/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllCurrencyPairConfiguration': {
                method: 'GET',
                isArray: true,
                url: 'api/manage-currency-pair-configuration/',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	method:'POST',
            	params: {corpId:'@corpId'},
                url: 'api/manage-currency-pair-configuration/:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'bankupdate': {
            	method:'POST',
            	params: {corpId:'@corpId'},
                url: 'api/manage-bank-currency-pair-configuration//:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmitForCreate': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmit/manage-currency-pair-configuration',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
        });
    }
})();